import pick from 'lodash/pick';
import { IPartnershipModel } from '../model';

export default (self: IPartnershipModel) => {
  return {
    // the organization side of the partnership, to see one organization's partners
    get partnershipOrganizationFilterTags() {
      return self.organizationName ? [self.organizationName] : [];
    },
    get filterTags() {
      return self.partnershipOrganizationFilterTags.map((tag) => tag.toLowerCase());
    },
    get searchString() {
      const searchFields = ['partnerName', 'partnerExternalId', 'organizationName', 'organizationExternalId', 'partnerAddress'];
      return Object.values(pick(self, searchFields)).join(' ').toLowerCase();
    }
  };
};
